<template>
  <div>
    <v-header></v-header>

    <div   class="container" style="padding-top: 60px;">
      <div   class="banner">
        <img   src="../../static/img/banner-2.png" alt="" />
        <h2 class="item-title">
           <span class="eg" style="color:rgba(255,255,255,1);"> 中学信息化解决方案，提升学校管理效率</span>
           <span class="ch">  一站式掌握教职工管理、学生管理、家校互联、教务办公等核心业务管理</span>
        </h2>
      </div>
      <!-- <div   class="introduction">
        <h2   class="item-title"><span   class="eg">PRODUCT INTRODUCTION</span> <span   class="ch">产品简介</span></h2>
        <p   class="product-introduction">为新高考课改定制的排课算法，针对 “7 选 3”或“6 选 3”带来的选课、分班、排课、成绩分析等问题，通过智能算法，为老师、学生、学校提供个性化、专业走班排课解决方案，便捷的调课代课操作，课表统一管理。</p>
      </div> -->
      <div   class="features">
        <h2   class="item-title"><span   class="eg">选择凡高，一站式助您解决校园管理问题</span> </h2>
        <div   class="item-pro" style="margin-top:40px">
          <dl  >
            <dt  >
              <span>教职工管理难度大，考核难以量化</span>
            </dt>
            <dd >
              <img src="../../static/img/pay-one.png" alt="">
              <span>详细记录教职工信息档案，请销假考勤流程规范，便捷，记录清晰。</span>
            </dd>
          </dl>

          <dl  >
            <dt  >
              <span>学生信息乱杂，难以规范</span>
            </dt>
            <dd >
              <img src="../../static/img/pay-two.png" alt="">
              <span>各校区，各年级学生信息规范化管理，请假出入校系统为学生安全保驾护航</span>
            </dd>
          </dl>

        </div>
        <div class="item-pro">
          
          <dl  >
            <dt  >
              <span>家校沟通有障碍，老师，家长压力大</span>
            </dt>
            <dd >
              <img src="../../static/img/pay-three.png" alt="">
              <span>学生在校学习，生活，消费安全等信息一键通知到家长，校内外信息不漏点滴</span>
            </dd>
          </dl>

          <dl  >
            <dt  >
              <span>学校管理多而杂，费时费力</span>
            </dt>
            <dd >
              <img src="../../static/img/pay-four.png" alt="">
              <span>打通多系统数据，教务财务，后勤仓储等，给您一个统一的信息化解决方案</span>
            </dd>
          </dl>
        </div>
      </div>
      <div   class="process">
        <h2   class="item-title"><span   class="eg">功能强大，精准覆盖校园管理每个痛点</span></h2>
       <div class="item-pro">
         <img src="../../static/img/pay-five.png" alt="">
         <p class="title">管控每位教职工档案，请销假考勤便捷精准高效，通知公告一键下发</p>
         <p class="note">跨校区管理，自定义创建部门架构，随时掌握最新的在职教师数信息，档案电子化管理；安全清晰教职工便捷考勤，请销假智能管理，自动生成考勤记录，简化请销假流程，考勤数据一目了然；移动端随时随地接收通知公告，学校通知、审批通知、学生信息...，一键自动下发校园管理无盲区。</p>
       </div>

         <div class="item-pro">
            <img src="../../static/img/pay-six.png" alt="">
            <p class="title">学生学籍管理一览无余，门禁、请假出入校管理，校园安全无死角</p>
            <p class="note">自定义创建学生组织架构，全方面包含学生信息，调班、转入、转出；退学自动生成记录，学籍档案统计报表一览无余；学生请销假，出入校，系统化的统计，出入校信息一件下达；相关老师和学生家长，线上流程简单易操作，消息一目了然；通过人脸识别技术，严格把控学生出入校园宿舍，从教室到宿舍安全校园再无死角。</p>
          </div>

         <div class="item-pro">
            <img src="../../static/img/pay-seven.png" alt="">
            <p class="title">学生在校学习，生活信息教师家长随时共享，在线沟通共筑家校共育</p>
            <p class="note">学生出入校情况精准记录，消息一键推送，家长可移动端随时随地查看，学生在校情况，孩子动态一目了然，学生成绩查询，在校消费情况，随时掌握、随时接收校园通知公告，老师省心，学生舒心，家长放心。</p>
          </div>

         <div class="item-pro">
            <img src="../../static/img/pay-eight.png" alt="">
            <p class="title">教务办公</p>
            <p class="note">绝大多数学校缺少统一管理平台，多系统数据无法打通；几个系统来回切换，效率低，凡高助您打通多系统数据，教务财务、后勤仓储等，给您一个完整的信息化解决方案。</p>
          </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px;
  }
  .banner {
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img {
    width: 100%
  }

  .banner .item-title{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
    color:rgba(255,255,255,1);
  }
  .banner .item-title .ch{
  width:389px;
height:50px;
font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
margin-top: 30px;
  }
  .banner .item-title .eg{
   width:499px;
font-size:40px;
font-family:PingFang SC;
font-weight:400;
/* color:rgba(255,255,255,0.3); */
  }

  .introduction {
    padding: 50px 0
  }

  .features {
    /* background: #f9f9f9; */
    padding: 100px 0
  }
.features .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

.features  .item-title .eg{
    width:441px;
   font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);

  }
  .features .item-pro {
    padding: 0;
    width: 97%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin: 0px auto;
  }

  .features .item-pro dl {
    flex: 1;
    margin: 20px 15px;
   
    height:420px;
    background:rgba(255,255,255,1);
    border-radius:10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  }

  .features .item-pro dt {
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;

    height:110px;
    background:linear-gradient(-45deg,rgba(42,177,243,1),rgba(42,212,243,1));
    border-radius:10px 10px 0px 0px;
  }
.features .item-pro dt span{
  font-size:24px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:36px;
  /* margin-top: 25px; */
  width: 78%;
  text-align: center;
  margin: auto;
}
  .features .item-pro dd img {
    width: 80px;
    height: 80px;
    text-align: center;
    margin: 30px auto;
  }

  .features .item-pro dd {
    width: 100%;
    text-align: center;
    margin: 15px 0 0
  }

  .features .item-pro dd span {
   width:79%;
height:131px;
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(14,5,10,1);
line-height:36px;
display: inline-block;
  }

  .process {
    /* padding: 100px 0 */
    padding-top: 0px;
    padding-bottom: 100px;
  }
.process .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }
.process  .item-title .eg{
   font-size:36px;
  font-family:PingFang SC;
  font-weight:bold;
  color:rgba(0,0,0,1);
  line-height:54px;
  width:403px;

  }
   .process .item-pro {
    padding: 0;
    width: 89%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin: 0px auto;
    margin-top: 80px;
  }
  .process .item-pro img{
    width: 320px;
    height: 240px;
    text-align: center;
    margin: 0 auto;
  }

 .process .item-pro .title{
font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
line-height:45px;
margin: 30px 0;
 }
 .process .item-pro .note{
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
 }
</style>



// WEBPACK FOOTER //
// src/components/classselection.vue